// Libs
import { Libraries } from '@react-google-maps/api';
// Others
import { JobFilterPaymentEnum, ReportFilterShowByEnum } from '~/utils/enum/common';
import { IBaseOption, IQueryParamBase } from '~/utils/interface/common';

// String
export const DEFAULT_ESTIMATE_FILE_NAME_PDF = 'estimate.pdf';
export const DEFAULT_PAYROLL_FILE_NAME_PDF = 'payroll.pdf';
export const POUND = '#';
export const PERCENTAGE = '%';
export const LANGUAGES = ['en'];
export const EMPTY_STRING = '';
export const FILE_UPLOAD_TYPE_STARTS_WITH_IMAGE = 'image/';
export const FILE_UPLOAD_DEFAULT_ACCEPT_TYPE = '*';
export const SEARCH_BY_KEY = 'searchBy';
export const ASTERISK_SYMBOL = '*';
export const CONTENT_TYPE_FORM_DATA = 'multipart/form-data';
export const FILE_UPLOAD_DEFAULT_ACCEPT_IMAGE = 'image/*';
export const ACCEPT_ALL_FILES = '*/*';
export const NAVIGATION_AUTH = '/';
export const DEFAULT_VALUE_EMPTY_RICH_EDITOR = '<p><br></p>';
export const DEFAULT_VALUE_FILTER = 'ALL';
export const DEFAULT_LABEL_FILTER = 'All';
export const COMMA_SEPARATOR = ',';
export const DEFAULT_CURRENCY = '$0.00';
export const DEFAULT_CURRENCY_ZERO = '$0';
export const ENTER_KEY = 'Enter';
export const SPACE = ' ';
export const DASH = '-';
export const ACCEPT_UPLOAD_DOCUMENT_MESSAGE =
  'video/mp4, audio/mpeg, image/png, image/jpeg, image/jpg, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/pdf';
/** React Dropzone v14 accept map aligned with backend fileFilter.document whitelist */
export const ACCEPT_DOCUMENT_FILES = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/gif': ['.gif'],
  'video/mp4': ['.mp4'],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'text/csv': ['.csv'],
};
export const EMAIL_SYSTEM = 'booking@NoblePlumbers.com';
export const PHONE_SYSTEM = '2095665420';
export const MESSAGE_SEND_INVOICE_DEFAULT =
  'Thank you for choosing Noble Plumbing to take care of all your plumbing needs.';
export const MESSAGE_GOOGLE_CONNECTED = 'MESSAGE_GOOGLE_CONNECTED';
export const MESSAGE_QUICK_BOOK_CONNECTED = 'MESSAGE_QUICK_BOOK_CONNECTED';
export const DEFAULT_FILE_NAME_TIME_CLOCK = 'report_time_clock';

// Number
export const DEFAULT_NUMBER_ZERO = 0;
export const DEFAULT_RATING = 5;
export const DEFAULT_NUMBER_ONE = 1;
export const DEFAULT_NUMBER_THREE = 3;
export const RANDOM_RANGE = 1000;
export const BACK_TO_PREVIOUS_PAGE = -1;
export const MAX_SIZE_FILE_UPLOAD = 50 * 1024 * 1024;
export const DEFAULT_LIMIT_PAGE = 10;
export const DEFAULT_LIMIT_GOOGLE_GMAIL = 15;
export const DEFAULT_LIMIT_1000 = 1000;
export const MAX_SELECTED_ITEM = 1000;
export const DEFAULT_DEBOUNCE_DELAY_TIME = 300;
export const DEFAULT_TOOLTIP_DELAY = 300;
export const DEFAULT_QUALITY_IMAGE = 0.6;
export const DEFAULT_MAX_HEIGHT_IMAGE = 720;
export const DEFAULT_MAX_WIDTH_IMAGE = 1280;
export const TIME_CLOSE_TOAST = 4000;
export const TIME_OUT_SHOW_TOAST = 1000;
export const TIME_OUT_SHOW_TOAST_ERROR = 200;
export const TIME_OUT_SHOW_TOAST_SUCCESS = 1000;
export const TIME_OUT_SHOW_COMPLETE = 2000;
export const DEFAULT_LIMIT_SURPLUS = 10;
export const DEFAULT_HEIGHT_INPUT_MESSAGE = 18;
export const DEFAULT_LIMIT_COUNT_MESSAGE = 99;
export const DEFAULT_TIMEOUT_RECONNECT_WSS = 3000;
export const MAX_TIMEOUT_RECONNECT_WSS = 30000;
export const DEBOUNCE_SEEN_MESSAGE_DELAY = 500;
export const NEW_NOTIFICATION_THRESHOLD = 10;
export const DEFAULT_MIN_YEAR = 1900;
export const QUERY_TOKEN = 'token';

// Roles
export const ROLES = [
  {
    id: '00001',
    name: 'Admin',
  },
  {
    id: '00002',
    name: 'Staff',
  },
  {
    id: '00003',
    name: 'Technician',
  },
];

// Component
export const FILE_UPLOAD_PROP_MAX_FILE = 10;
export const FILE_UPLOAD_PROP_MIN_FILE = 1;
export const FILE_UPLOAD_PROP_MULTIPLE = false;
export const FILE_UPLOAD_PROP_REQUIRED = false;

export const BASE_PAGINATION_DEFAULT_CURRENT_PAGE = 1;
export const BASE_PAGINATION_ROW_PER_PAGE_OPTIONS = [10, 20, 50];

export const FILTER_DEFAULT_VALUES: IQueryParamBase = { fields: [] };

export const DEFAULT_LENGTH_OTP = 6;

export const DEFAULT_LIMIT_EMAIL = 5;

export const EVENT_COLOR_DEFAULT = '#B8E6FE';
export const SCHEDULE_MODE_FULL = 'full';
export const SCHEDULE_MODE_MY = 'my';
export const VIEW_MODE_MONTH = 'month';
export const DEFAULT_VIEW_MODE = 'month';

// Regex
export const REG_EXP = {
  NUMBER: /[^\d]/g,
  IS_NUMBER: /^[0-9]*$/,
  VERIFY_CODE: /^\d?$/,
  NON_DIGIT_REGEX: /[^\d]/g,
  NUMBER_MAX_LENGTH_SIX: /^[0-9]{6}$/,
  IS_IMAGE: /\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i,
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  PHONE_NUMBER: /^\(\d{3}\) \d{3}-\d{4}$/,
};

// Format number
export const FORMAT_NUMBER = {
  numberThree: 3,
  numberFour: 4,
  numberSix: 6,
  numberSeven: 7,
  numberTen: 10,
};

// Google Map
export const DEFAULT_POSITION = { lat: 0, lng: 0 };
export const DEFAULT_MAP_ZOOM = 17;
export const DEFAULT_GG_MAP_LOAD_SCRIPT_LIB: Libraries = ['places'];

// Options Rich Editor
export const toolbarOptionsRichEditor = [
  [
    { header: [1, 2, 3, 4, 5, 6, false] },
    'bold',
    'italic',
    'underline',
    'strike',
    {
      color: [
        '#000000',
        '#e60000',
        '#ff9900',
        '#ffff00',
        '#008a00',
        '#0066cc',
        '#9933ff',
        '#ffffff',
        '#facccc',
        '#ffebcc',
        '#ffffcc',
        '#cce8cc',
        '#cce0f5',
        '#ebd6ff',
        '#bbbbbb',
        '#f06666',
        '#ffc266',
        '#ffff66',
        '#66b966',
        '#66a3e0',
        '#c285ff',
        '#888888',
        '#a10000',
        '#b26b00',
        '#b2b200',
        '#006100',
        '#0047b2',
        '#6b24b2',
        '#444444',
        '#5c0000',
        '#663d00',
        '#666600',
        '#003700',
        '#002966',
        '#3d1466',
      ],
    },
    { list: 'ordered' },
    { list: 'bullet' },
    { indent: '-1' },
    { indent: '+1' },
    { script: 'sub' },
    { script: 'super' },
    'link',
    'image',
  ],
];

export const toolbarOptionsRichEditorReview = [
  [
    { header: [1, 2, 3, 4, 5, 6, false] },
    'bold',
    'italic',
    'underline',
    'strike',
    {
      color: [
        '#000000',
        '#e60000',
        '#ff9900',
        '#ffff00',
        '#008a00',
        '#0066cc',
        '#9933ff',
        '#ffffff',
        '#facccc',
        '#ffebcc',
        '#ffffcc',
        '#cce8cc',
        '#cce0f5',
        '#ebd6ff',
        '#bbbbbb',
        '#f06666',
        '#ffc266',
        '#ffff66',
        '#66b966',
        '#66a3e0',
        '#c285ff',
        '#888888',
        '#a10000',
        '#b26b00',
        '#b2b200',
        '#006100',
        '#0047b2',
        '#6b24b2',
        '#444444',
        '#5c0000',
        '#663d00',
        '#666600',
        '#003700',
        '#002966',
        '#3d1466',
      ],
    },
    { list: 'ordered' },
    { list: 'bullet' },
    { indent: '-1' },
    { indent: '+1' },
    { script: 'sub' },
    { script: 'super' },
    'link',
  ],
];

export const employeeColors: string[] = [
  '#DFF3E4',
  '#F7E4DC',
  '#ECF6FF',
  '#F4E5FF',
  '#E5E6FF',
  '#E5F9FF',
  '#FBFFE5',
  '#FFF5E5',
  '#FFE5E5',
  '#FFE5EE',
];

export const taskStatusOptions: IBaseOption[] = [
  { value: 'TODO', label: 'Todo' },
  { value: 'IN_PROGRESS', label: 'In Progress' },
  { value: 'DELAY', label: 'Delay' },
  { value: 'COMPLETED', label: 'Completed' },
];

export const typeLinkQuickBooksOptions: IBaseOption[] = [
  { value: 'NO', label: 'No' },
  { value: 'ADD_NEW', label: 'Add New' },
  { value: 'ADD_EXISTING', label: 'Add Existing' },
];

export const techReportOptions: IBaseOption[] = [
  { label: 'Current Month', value: ReportFilterShowByEnum.MONTH },
  { label: 'Current Year', value: ReportFilterShowByEnum.YEAR },
  { label: 'Custom Date', value: ReportFilterShowByEnum.DAY },
];

export const legendChart: { [key: string]: string } = {
  // Job Count
  JOB_COUNT_LAST_YEAR: 'chart_job_count_type_last_year',
  JOB_COUNT_CURRENT_YEAR: 'chart_job_count_type_current_year',

  // Estimate Sold
  ESTIMATE_SOLD: 'chart_estimate_sold_type_won',

  // Technician
  COMPLETED: 'chart_technician_service_volume_legend_complete',
};

// Technician reports
export const technicianServiceVolumeLegend: { [key: string]: string } = {
  COMPLETED: 'chart_technician_service_volume_legend_complete',
};
export const technicianJobAverageLegend: { [key: string]: string } = {
  COMPLETED: 'chart_technician_job_average_legend_complete',
};
export const technicianPoTotalLegend: { [key: string]: string } = {
  COMPLETED: 'chart_technician_po_total_legend_complete',
};
// Sale by City reports
export const saleByCityLegend: { [key: string]: string } = {
  COMPLETED: 'chart_sale_by_city_job_revenue_legend_complete',
};

// Dropdown - Options
export const jobFilterPaymentOptions: IBaseOption[] = [
  { label: 'All', value: JobFilterPaymentEnum.ALL },
  { label: 'Missing Payment', value: JobFilterPaymentEnum.MISSING_PAYMENT },
];
